export default __webpack_public_path__ + "static/media/check-small.acf71f6b.svg";